import {getRequest, postRequest} from '../../../../middlewares/api/actions';
import {
  getConvertPxToCsvUrl,
  getConvertXlsToCsv,
  getImportCsvUrl,
  getUploadFileOnServerUrl
} from '../../../../constants/urls';

export const LOADER_CSV_FORM_CHANGE = 'LOADER_CSV_FORM_CHANGE';
export const LOADER_CSV_FORM_FILE_UPLOAD = 'LOADER_CSV_FORM_FILE_UPLOAD';
export const LOADER_CSV_FORM_SUBMIT = 'LOADER_CSV_FORM_SUBMIT';
export const LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE = 'LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE';
export const LOADER_CSV_FORM_PX_TO_CSV_CONVERT = 'LOADER_CSV_FORM_PX_TO_CSV_CONVERT';
export const LOADER_CSV_FORM_XLS_TO_CSV_CONVERT = 'LOADER_CSV_FORM_XLS_TO_CSV_CONVERT';

export const changeLoaderCsvForm = fields => ({
  type: LOADER_CSV_FORM_CHANGE,
  fields
});

export const uploadLoaderCsvFormFile = (file, mappingCubeId, format) => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return ({
    format,
    ...postRequest(
      LOADER_CSV_FORM_FILE_UPLOAD,
      getUploadFileOnServerUrl(mappingCubeId),
      fileFormData,
      t => ({
        start: t('scenes.dataManager.loader.csvForm.messages.fileUpload.start'),
        success: t('scenes.dataManager.loader.csvForm.messages.fileUpload.success')
      })
    )
  });
};

export const submitLoaderCsvForm = (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload) => ({
  ...getRequest(
    'LOADER_CSV_FORM_SUBMIT',
    getImportCsvUrl(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload),
    t => ({
      start: t('scenes.dataManager.loader.csvForm.messages.submit.start'),
      success: t('scenes.dataManager.loader.csvForm.messages.submit.success')
    })
  ),
  reportFileNameId: cubeCode
});

export const onHideLoaderCsvFormIgnoreConcurrentUploadConfirm = () => ({
  type: LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE
});

export const convertLoaderCsvFormPxToCsv = (fileServerPath, cubeId) => getRequest(
  LOADER_CSV_FORM_PX_TO_CSV_CONVERT,
  getConvertPxToCsvUrl(fileServerPath, cubeId)
);

export const convertLoaderCsvFormXlsToCsv = (fileServerPath, xmlServerPath, cubeId) => getRequest(
  LOADER_CSV_FORM_XLS_TO_CSV_CONVERT,
  getConvertXlsToCsv(fileServerPath, xmlServerPath, cubeId)
);


// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/csv-form/actions.js